// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1CdHh","resendInfoText":"OnGoingPaymentBox_resendInfoText__2rMcs"};